
import React, {useEffect, useRef} from 'react'
import { Row } from "antd";
import { TrophyOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledDiv = styled.div`
    font-family: "Poppins", sans-serif;
`;

const PurposeCommit1 = () => {
    const serviceRef = useRef(null)
    useEffect(() => {
        
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('fadeInLeft1')
              }
            })
          },
          {
            threshold: 0.5
          }
        )

        const serviceRefCurrent = serviceRef.current
    
        if (serviceRefCurrent) {
          observer.observe(serviceRefCurrent)
        }
    
        return () => {
          if (serviceRefCurrent) {
            observer.unobserve(serviceRefCurrent)
          }
        }
      
    }, [])

    return (
        <>
            <StyledDiv
                style={{
                    marginTop: "20px"
                }}
                className='landingCommitmentText'
                ref={serviceRef}
            >
                <Row justify="start">
                    <TrophyOutlined className="landingCommitmentIcon" /> 
                    <label style={{
                      marginTop: "4px"
                    }}>Deliver Exceptional Performance</label>
                </Row>
                {/* <label>•	Deliver Exceptional Performance</label> */}
            </StyledDiv>
        </>
    )
}

export default PurposeCommit1
